import { combineReducers } from "redux";


import authUser from "./auth/login";
import authVerify from "./auth/verify";
import regions from './regions'
import users from './users/getUsers'
import account from './auth/account'
import batchDistributionCart from './distribution/distributedRecordStore'
import assetDetail  from "./assets/assetDetail";
import pieMetrics  from "./analytics/assets-metrics/assetsPie.metrics";
import lineProgressMetrics  from "./analytics/assets-metrics/assetsLineProgress.metrics";
import  dispatchCart  from "./distribution/dispatchRecord";
import dashboard from "./analytics/dashboard.reducer";
import assetMetrics from './analytics/asset.metrics'
import maintenanceSchedulesMetrics  from "./analytics/maintenance-schedule.metrics"
import domainMetrics from './analytics/domain.metrics'
import userMetrics from './analytics/user.metrics'

const appReducers = combineReducers({
    authUser,
    authVerify,
    account,
    regions,
    users,
    batchDistributionCart,
    assetDetail,
    pieMetrics,
    lineProgressMetrics,
    dispatchCart,
    dashboard,
    assetMetrics,
    maintenanceSchedulesMetrics,
    domainMetrics,
    userMetrics

});

export default appReducers;
